<h2 mat-dialog-title class="gl-preview-header">
  <span class="gl-preview-title">{{ data.title }}</span>
  <span class="gl-preview-badges" *ngIf="!loading && !error && !infoMessage && lines.length">
    <span class="badge badge-debit">Debits {{ debitTotal | currency }}</span>
    <span class="badge badge-credit">Credits {{ creditTotal | currency }}</span>
  </span>
</h2>

<mat-dialog-content class="gl-preview-content">
  <div *ngIf="data.allowResample" class="gl-preview-scope-row">
    <mat-checkbox
      color="primary"
      [checked]="limitToCurrentYear"
      (change)="onSampleScopeChange($event.checked)">
      Limit sample to current calendar year
    </mat-checkbox>
  </div>
  <div *ngIf="loading" class="gl-preview-skeleton">
    <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7,8]"></div>
  </div>

  <div *ngIf="error" class="gl-preview-error">
    {{ error }}
  </div>

  <div *ngIf="infoMessage && !loading" class="gl-preview-info">
    {{ infoMessage }}
  </div>

  <ng-container *ngIf="!loading && !error && !infoMessage && lines.length">
    <div class="gl-preview-export-actions">
      <button mat-stroked-button type="button" color="primary" (click)="exportXlsx()" matTooltip="Export Excel">
        <mat-icon>table_chart</mat-icon>
        Excel
      </button>
      <button mat-stroked-button type="button" (click)="exportPdf()" [disabled]="exportingPdf" matTooltip="Export PDF">
        <mat-icon>picture_as_pdf</mat-icon>
        PDF
      </button>
      <mat-spinner *ngIf="exportingPdf" diameter="22" class="gl-preview-export-spinner"></mat-spinner>
    </div>

    <div #pdfExportRoot class="gl-preview-pdf-root">
      <p *ngIf="assumptions.length" class="gl-preview-assumptions">
        {{ assumptions.join(' ') }}
      </p>
      <div class="gl-preview-ledger">
        <div *ngIf="!balanced" class="gl-preview-warning">
          Debits and credits do not balance. Review before posting.
        </div>

        <div class="gl-preview-table-wrap gl-preview-table-wrap--single">
          <table class="gl-preview-table gl-preview-table--ledger-sheet">
            <thead>
              <tr>
                <th scope="col" class="col-date" *ngIf="showDates">DATE</th>
                <th scope="col" class="col-acct">ACCT</th>
                <th scope="col" class="col-name">NAME</th>
                <th scope="col" class="col-narrative">NARRATIVE</th>
                <th scope="col" class="col-debit">DEBIT</th>
                <th scope="col" class="col-credit">CREDIT</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let line of lines"
                [class.ledger-row--debit]="line.side === 'debit'"
                [class.ledger-row--credit]="line.side === 'credit'">
                <td class="mono" *ngIf="showDates">
                  {{ line.trandate || '—' }}
                  <mat-icon *ngIf="line.date_adjusted"
                    class="gl-preview-date-flag"
                    matTooltip="Dated in a closed period — this is the date it will post under">
                    event_busy
                  </mat-icon>
                </td>
                <td class="mono">{{ line.account }}</td>
                <td class="account-name-cell" [matTooltip]="line.account_name" matTooltipShowDelay="400">{{ line.account_name }}</td>
                <td class="narrative-cell" [matTooltip]="line.narrative" matTooltipShowDelay="400">{{ line.narrative }}</td>
                <td class="amount amount-debit">{{ line.side === 'debit' ? (line.amount | currency) : '' }}</td>
                <td class="amount amount-credit">{{ line.side === 'credit' ? (line.amount | currency) : '' }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="gl-preview-tfoot-row">
                <td [attr.colspan]="showDates ? 4 : 3" class="total-label">Totals</td>
                <td class="amount amount-debit">{{ debitTotal | currency }}</td>
                <td class="amount amount-credit">{{ creditTotal | currency }}</td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div class="gl-preview-balance" [class.balanced]="balanced" [class.unbalanced]="!balanced">
          <span *ngIf="balanced">Balanced</span>
          <span *ngIf="!balanced">Out of balance by {{ (debitTotal - creditTotal) | currency }}</span>
        </div>
      </div>
    </div>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gl-preview-actions gl-preview-actions-row">
  <span class="gl-preview-actions-spacer"></span>
  <button
    *ngIf="data.allowResample && !loading && lines.length"
    mat-stroked-button
    type="button"
    color="primary"
    (click)="anotherTransaction()">
    Another transaction
  </button>
  <button
    *ngIf="data.allowResample && !loading && (lines.length || sampleExhausted)"
    mat-stroked-button
    type="button"
    (click)="startOverSamples()">
    Start over
  </button>
  <button mat-raised-button color="primary" type="button" (click)="close()">Close</button>
</mat-dialog-actions>
